import React from 'react';

import Authentication from 'components/Authentication';
import ExternalScripts from 'components/ExternalScripts';
import AppLayout from 'layout/App';
import BnplLimitManagementScreen from 'screens/BnplLimitManagementScreen';
import DaktelaCustomerChat from 'sections/DaktelaCustomerChat';

function Page(): JSX.Element {
	return (
		<Authentication>
			<AppLayout simple withoutSideMenu>
				<ExternalScripts secured />
				<DaktelaCustomerChat pageType="self-care" />
				<BnplLimitManagementScreen />
			</AppLayout>
		</Authentication>
	);
}

export default Page;
